/// <reference types="vite/client" />

import send from 'service/index';
import axios from 'axios';
import HiCache from 'utils/cache';
import HiStance from 'utils/HiStance';

export default {
    getFrontLanguages() {
        return send({
            url: '/sys/merchantLanguage/getFrontLanguages',
            method: 'get',
        });
    },
    getUserInfo(params: any = {}) {
        return send({
            url: '/member/getUserInfo',
            params,
        });
    },
    getLotteryUserInfo(params: any = {}) {
        return send({
            url: '/member/findMemberOfficialLotteryBalance',
            params,
        });
    },
    //不需要登录的UserInfo
    getNotUserInfo(params: any = {}) {
        return send({
            url: '/member/getNotUserInfo',
            params,
        });
    },
    login(data: any = {}) {
        return send({
            url: '/member/login',
            method: 'post',
            data,
        });
    },
    // 获取所有证件类型
    getIdentificationTypeEnums(params = {}) {
        return send({ params, url: '/member/getIdentificationTypeEnums' });
    },
    // 用户注册
    register(data: any = {}) {
        return send({ data, url: '/member/register', method: 'POST' });
    },
    // 用户注册
    getLoginConfig(params: any = {}) {
        return send({ params, url: '/member/getLoginConfig', method: 'get' });
    },
    // 刷新token
    refreshToken(data: any = {}) {
        return send({ data, url: '/member/refreshToken', method: 'POST' });
    },
    // 退出登录
    logout(params: any = {}) {
        return send({ params, url: '/member/logout', method: 'get' });
    },
    // 获取验证码
    getCaptcha(params = {}) {
        return send({ params, url: '/member/getCaptcha', method: 'get' });
    },
    // 获取等级活动
    getLevelActivityList(data = {}) {
        return send({ data, url: '/member/getLevelActivityList', method: 'post' });
    },
    // 领取晋级彩金
    signLevelActivity(data: any = {}) {
        return send({ data, url: `/preferential/preferentialActivity/signLevelActivity/${data?.id}`, method: 'post' });
    },
    // 获取轮盘奖品信息
    getUserRoulette(data = {}) {
        return send({ data, url: '/roulette/findUserRoulette', method: 'post' });
    },
    // 获取轮盘奖品信息
    getUserRouletteById(data: any = {}) {
        return send({ data, url: `/roulette/findRoulette/${data?.sn}`, method: 'post' });
    },
    // 获取轮盘抽奖结果
    getRouletteStart(data = {}) {
        return send({ data, url: '/roulette/userDraw', method: 'post' });
    },
    // 获取轮盘抽奖列表
    getRouletteFindTime(data: any = {}) {
        return send({ data, url: `/roulette/findTime/${data?.top}`, method: 'post' });
    },
    // 获取轮盘抽奖排行榜
    getLeaderboardList(data = {}) {
        return send({ data, url: '/roulette/leaderboardList', method: 'post' });
    },
    // 获取首页轮播图
    getCarouselListTop(params: any = {}) {
        return send({ url: `/content/contentAds/homeAds` });
    },
    // 站内消息
    getMyMessageNoticeList(data = { current: 1, size: 10 }) {
        return send({
            url: `/member/memberUserMessage/findPage/${data.current}/${data.size}`,
            method: 'POST',
        });
    },
    // 站内未读消息条数
    getUnReadCountMessage() {
        return send({
            url: `/member/memberUserMessage/unreadCount`,
            method: 'get',
        });
    },
    // 更换用户图像
    updateHeadPortrait(data = { id: 1, headPortrait: 'home/userImg1.png' }) {
        return send({
            url: `/member/updateHeadPortrait`,
            method: 'POST',
            data,
        });
    },

    // 已登录状态发送手机或邮箱验证码
    getSendCodeByUserId(data: any = {}) {
        return send({ data, url: '/member/sendCodeByUserId', method: 'post' });
    },

    //  绑定手机号
    bindMobile(data: any = {}) {
        return send({ data, url: '/member/bindMobile', method: 'post' });
    },

    // 未登录状态发送手机或邮箱验证码
    getSendCode(data: any = {}) {
        return send({ data, url: '/member/sendCode', method: 'POST' });
    },
    // 修改密码
    modifyPassword(data = {}) {
        return send({ data, url: '/member/editPassWord', method: 'POST' });
    },
    // 添加资金密码
    addMoneyPassword(data = {}) {
        return send({ data, url: '/member/editPassWord', method: 'POST' });
    },
    // 忘记密码
    getForgetPassWord(data: any = {}) {
        return send({ data, url: '/member/forgetPassWord', method: 'POST' });
    },

    // 获取还需要继续完成资料的字段
    getNeedToComplete(params = {}) {
        return send({ params, url: '/member/getComplete' });
    },

    // 已完成会员资料
    getCompleteInfo(params = {}) {
        return send({
            params,
            url: `/member/getCompleteInfo`,
        });
    },
    // 每日任务列表
    getFindTaskList(params = {}) {
        return send({
            params,
            url: `/preferential/task/findTaskList`,
        });
    },
    // 每日任务列表
    getFindTaskApply(data = {}) {
        return send({
            data,
            url: `/preferential/task/apply`,
            method: 'POST',
        });
    },

    //获取vip等级列表
    getUserVipList() {
        return send({
            url: `/member/findUserVipList`,
            method: 'POST',
        });
    },

    //获取用户数量和返利金额
    getSumPreferentialMoney() {
        return send({
            url: `/member/findSumPreferentialMoney`,
            method: 'POST',
        });
    },
    // 活动详情页
    getContentAdsFindById(params: any = {}) {
        return send({ url: `/content/activity/findById/${params?.id}`, method: 'get' });
    },
    // 获取回收平台余额
    getRefreshBalance(data: any = {}) {
        return send({ data, url: `/member/findNewMemberBalance` });
    },
    // 获取平台余额
    getRecycleBalance(params: any = {}) {
        return send({ url: `/member/recycleBalance/${params?.company}` });
    },
    // 获取第三方快捷登录UUID
    async getGoogleLogin(params: any = {}) {
        return send({ url: `/oauth2/login/${params?.data?.sourceName}` });
        // @ts-ignore
        // if (import.meta.env.DEV) {
        //     try {
        //         let headers: any = {
        //             device: 'Pc',
        //             language: params?.language,
        //         };
        //         const token = HiCache.getCache(HiStance.TOKEN);
        //         if (params?.isLogin) {
        //             headers.Authorization = 'Bearer ' + token;
        //         }
        //         const response = await axios.get(`https://sky503v2-h5.xbnapi.xyz/oauth2/login/${params?.data?.sourceName}`, {
        //             headers,
        //         });
        //         return response.data;
        //     } catch (e) {
        //         return e;
        //     }
        // } else {
        //     try {
        //         let headers: any = {
        //             device: 'Pc',
        //             language: params?.language,
        //         };
        //         const token = HiCache.getCache(HiStance.TOKEN);
        //         if (params?.isLogin) {
        //             headers.Authorization = 'Bearer ' + token;
        //         }
        //         const response = await axios.get(`/oauth2/login/${params?.data?.sourceName}`, {
        //             headers,
        //         });
        //         return response.data;
        //     } catch (e) {
        //         return e;
        //     }
        // }
    },
    // 快捷登录列表
    async getFastLoginList(data: any = {}) {
        return send({ params: data, url: `/oauth2/findList`, method: 'get' });
    },
    // 第三方快捷注册登录
    async getFastRegister(data: any = {}) {
        return send({ data, url: `/oauth2/register`, methods: 'post' });
        // let headers: any = {
        //     device: 'Pc',
        //     language: data?.language,
        // };
        // // @ts-ignore
        // if (import.meta.env.DEV) {
        //     try {
        //         const response = await axios.post('https://sky503v2-h5.xbnapi.xyz/oauth2/register', data?.data, { headers });
        //         return response.data;
        //     } catch (e) {
        //         return e;
        //     }
        // } else {
        //     try {
        //         const response = await axios.post('/oauth2/register', data?.data, { headers });
        //         return response.data;
        //     } catch (e) {
        //         return e;
        //     }
        // }
    },
    // 获取首页公告
    getNotices(params = {}) {
        return send({ url: '/content/contentNotice/noticeList', method: 'get' });
    },
    // 获取精彩活动
    getHotActives() {
        return send({ url: `/content/activity/findHomeActivity` });
    },
    // 获取活动详情
    getActivityDetailList(params: any = {}) {
        return send({ url: `/content/activity/findById/${params.id}`, method: 'get' });
    },
    // 查看站内信消息
    getMyMessageRead(params = { id: 0 }) {
        return send({ params, url: `/member/memberUserMessage/read/${params.id}` });
    },
    // 获取登录验证码
    getIsShowCaptcha(params = {}) {
        return send({ params, url: '/member/getIsShowCaptcha', method: 'get' });
    },
    // 获取用户平台余额
    getBalanceByUser(data: any = {}) {
        return send({ data, url: `/game/queryCredit`, method: 'post' });
    },
    // 主平台回收余额
    getTranslateRecycle(data: any = {}) {
        return send({ data, url: `/game/recycling`, method: 'post' });
    },
    // 获取所有平台及余额
    getAllPlatform(data: any = {}) {
        return send({ data, url: `/game/GetAllPlatform` });
    },
    // 获取洗码记录
    getBetList(params = { gameType: 0 }) {
        return send({ params, url: `/fan/orderDetail/betList/${params.gameType}` });
    },
    // 提交洗码
    submitWashCode(params = { gameType: 0 }) {
        return send({ params, url: `/fan/orderDetail/receive/${params.gameType}` });
    },
    // 获取历史洗码记录
    getWashCodeHistory(params = { gameType: 0, current: 1, size: 10 }) {
        return send({ params, url: `/fan/orderDetail/historyPage/${params.gameType}/${params.current}/${params.size}` });
    },
    // 获取历史洗码详情
    getWashCodeHistoryDetailByNo(params: { [key: string]: any } = {}) {
        return send({ params, url: `/fan/orderDetail/historyDetail/${params?.fanshuiNo}` });
    },
    // 获取平台游戏用户洗码比例
    getVipPercent(data = {}) {
        return send({ data, url: '/fan/orderDetail/findVipPercent', method: 'POST' });
    },

    // /member/findCusAccountTop/2/4/1
    // 类型 1体育，2电子  条数/top/  是否查总派奖额 0.不查，1查
    // 请求jackpot数据
    getJackpotData(params: any = {}) {
        return send({ params, url: `/member/findCusAccountTop/${params?.type}/${params?.top}/${params?.isTotal}` });
    },

    // 请求充值记录
    getRechargeRecord(data: any = {}) {
        return send({ data, url: `/recharge/rechargeOrder/findMyRechargePage/${data?.page}/${data?.rows}`, method: 'POST' });
    },

    //  提现记录
    getWithdrawRecord(data: any = {}) {
        return send({ data, url: `/withdraw/withdrawOrder/findMyWithdrawPage/${data?.page}/${data?.rows}`, method: 'POST' });
    },

    // 获取账变类型数据
    getMoneyFlowType(params: any = {}) {
        return send({ params, url: `/agent/getMoneyFlowType/${params?.type}` });
    },

    //  账变记录
    getMoneyFlowList(data: any = {}) {
        return send({ data, url: `/member/memberFlow/findPage/${data?.page}/${data?.rows}`, method: 'POST' });
    },

    //  /roulette/findRecordsSum
    getRouletteRecordsSum(data: any = {}) {
        return send({ data, url: `/roulette/findRecordsSum`, method: 'POST' });
    },

    getRouletteRecordsPage(data: any = {}) {
        return send({ data, url: `/roulette/findRecordsPage/${data?.page}/${data?.rows}`, method: 'POST' });
    },

    // 获取总投注金额
    getChampionshipBetTotal(params: any = {}) {
        return send({ params: {}, url: `/preferential/preferentialActivity/findChampionshipBetTotal/${params?.preferentialActivityId}/${params?.dateType}` });
    },

    // 请求排行榜列表 /preferential/preferentialActivity/findChampionshipV2/
    getChampionshipV2(params: any = {}) {
        return send({ params, url: `/preferential/preferentialActivity/findChampionshipV2/${params?.activityId}/${params?.preferentialActivityId}/${params?.dateType}` });
    },

    // 请求排行榜规则 /preferential/preferentialActivity/findChampionshipRule/2
    getChampionshipRule(params: any = {}) {
        return send({ params, url: `/preferential/preferentialActivity/findChampionshipRule/2` });
    },

    // 请求我的奖励 /preferential/preferentialActivity/findPreferentialFlow/${page}/${rows} post
    getMyRewards(data: any = {}) {
        return send({ data, url: `/preferential/preferentialActivity/findPreferentialFlow/${data?.page}/${data?.rows}`, method: 'POST' });
    },
    // 获取登录后的活动
    getLoginHomeActivity(data: any = {}) {
        return send({ data, url: `/content/activity/findLoginHomeActivity` });
    },
    // 获取热门活动
    getHomeActivity(data: any = {}) {
        return send({ data, url: `/content/activity/findHomeActivity` });
    },
    // 首页公告弹窗
    homeDialogNoticeList(data: any = {}) {
        return send({ data, url: `/content/contentNotice/noticeList` });
    },
    // 获取未读消息数量
    countUnreadCount(data: any = {}) {
        return send({ data, url: `/content/contentNotice/countUnreadCount` });
    },
    // 获取站内信弹窗数据
    getMessageDialog(data: any = {}) {
        return send({ data, url: `/content/contentNotice/findUnreadMail` });
    },
    // 用户访问网站
    userVisit(data: any = {}) {
        return send({ data, url: `/member/visit`, method: 'POST' });
    },
    // firebase发送token
    sendRegistrationTokens(data: any = {}) {
        return send({ data, url: `/member/registrationTokens`, method: 'POST' });
    },
    // 获取利息宝信息
    getProfitInfo(data: any = {}) {
        return send({ data, url: `/interest/basicInfo`, method: 'POST' });
    },
    // 获取利息宝信息
    getProfitRecord(data: any = {}) {
        return send({ data, url: `/interest/findProfitRecord`, method: 'POST' });
    },
    // 获取利息宝记录
    getProfitRecordList(data: any = {}) {
        return send({ data, url: `/interest/findRecords/${data?.page}/${data?.size}`, method: 'POST' });
    },
    // 获取利息宝规则
    getProfitRules(data: any = {}) {
        return send({ data, url: `/interest/ruleIntro`, method: 'POST' });
    },
    // 利息宝转入
    getProfitMoveIn(data: any = {}) {
        return send({ data, url: `/interest/deposit`, method: 'POST' });
    },
    // 利息宝提现
    getProfitWithdraw(data: any = {}) {
        return send({ data, url: `/interest/withdraw`, method: 'POST' });
    },
    // 利息宝领取
    getProfitReceive(data: any = {}) {
        return send({ data, url: `/interest/receive`, method: 'POST' });
    },
    // 利息宝开关
    getProfitIsOpen(data: any = {}) {
        return send({ data, url: `/interest/isOpen`, method: 'POST' });
    },
    // 获取系统时间
    getSystemTime(data: any = {}) {
        return send({ data, url: `/member/getSystemTime` });
    },
    // 生成pwaToken
    pwaTokenGenerate(data: any = {}) {
        return send({ data, url: `/member/pwaTokenGenerate`, method: 'POST' });
    },
    // 根据pwaToken登录
    pwaTokenLogin(data: any = {}) {
        return send({ data, url: `/member/pwaTokenLogin/${data?.key}`, method: 'POST' });
    },
    // 获取首页展示前十用户数据
    getFindWinAccountTop(data: any = {}) {
        return send({ data, url: `/member/findWinAccountTop/10` });
    },
    // 获取右侧广告数据
    getRightBannerData(data: any = {}) {
        return send({ data, url: `/content/contentAds/adsList/130` });
    },
    // 赠送中心
    getPreferentialManualGift(data: any = {}) {
        return send({ url: `/preferential/preferentialManualGift/findPage/${data?.current}/${data?.size}` });
    },
    // 领取赠送中心
    getPreferentialManualGiftClaim(data: any = {}) {
        return send({ data, url: `/preferential/preferentialManualGift/receive`, method: 'POST' });
    },
    // 首存活动
    findFirstDayRecharge() {
        return send({ url: `/preferential/preferentialActivity/findFirstDayRecharge`, method: 'get' });
    },
    // 累充活动
    findGrandTotalRecharge() {
        return send({ url: `/preferential/preferentialActivity/findGrandTotalRecharge`, method: 'get' });
    },
    // 领取累充活动
    receiveGrandTotal(data: any = {}) {
        return send({ data, url: `/preferential/preferentialManualGift/receiveGrandTotal`, method: 'post' });
    },
    // 赠送中心Banner
    findGiftCenterBanner() {
        return send({ url: `/content/contentAds/findBanner/210`, method: 'get' });
    },
};
